<template xmlns:detail-list="http://www.w3.org/1999/html">
  <a-card :bordered="false" title="券码详情">
    <detail-list :col='1'>
      <detail-list-item term="券码名称">{{ detail.name }}</detail-list-item>
      <detail-list-item term="券码类型">{{ detail.typeStr }}</detail-list-item>
      <detail-list-item term="销售方式">{{ detail.sellWayStr }}</detail-list-item>
      <detail-list-item term="使用方式">{{ detail.useWayStr }}</detail-list-item>
      <detail-list-item term="派发方式">{{ detail.distributeWayStr }}</detail-list-item>
      <detail-list-item term="券码来源">{{ detail.sourceStr }}</detail-list-item>
      <detail-list-item term="发送条数">
        <span v-if="detail.freeNum==0">仅一条</span>
        <span v-else>买一送{{ detail.freeNum|chineseCharactersName }}</span>
      </detail-list-item>
      <detail-list-item term="生成码数">
        {{ detail.stockNum }}
        <a-button type="primary" style="margin-left:20px" @click="addNum" v-if="detail.usedNum>0">增加码数</a-button>
      </detail-list-item>
      <detail-list-item term="激活人信息" v-if="detail.type=='JHM'">
        <LinkmanItem ref="linkMan" :contractMessage="detail.activateContractInfo"
                     :requiredList="detail.activateMustContractInfo"
                     :isDisabled="true"
                     @change="changeLinkMan"
        ></LinkmanItem>
      </detail-list-item>
      <detail-list-item term="关联商品">
        <div v-if="detail.proName">商品ID:{{ detail.proId }} 商品名称:{{ detail.proName }}</div>
        <div v-if="detail.optionName">套餐ID:{{ detail.optionId }} 套餐名称:{{ detail.optionName }}</div>
      </detail-list-item>
      <detail-list-item term="有效期">{{ getDateStr(detail) }}</detail-list-item>
    </detail-list>
    <a-button @click="backEvent">返回</a-button>
    <a-modal
      title="增加码数"
      :visible="visible"
      :width="600"
      @cancel="visible = false"
      :footer="null"
    >
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item v-if="detail.source === 'IN'" label="增加码数" prop="addStock">
          <a-input-number
            :min="0"
            :max="1000"
            v-model="ruleForm.addStock"
            :formatter="limitNumber"
            :parser="limitNumber"
          />
        </a-form-model-item>
        <a-form-model-item v-else label="增加码数" prop="redeemCodeList">
          <a-textarea
            v-model="ruleForm.redeemCodeList"
            placeholder="每行一个，多个换行即可"
            :maxLength="1000"
            :rows="4"></a-textarea>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" @click="onSubmit">提交</a-button>
          <a-button style="margin-left: 8px" @click="visible = false">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import formMixin from '@/utils/mixins/formMixins'
import LinkmanItem from '@/views/product/productGroup/components/LinkmanItem'

export default {
  name: 'CouponCodeDetail',
  mixins: [formMixin],
  components: { LinkmanItem },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      id: '',
      detail: {},
      visible: false,
      ruleForm: {},
      rules: {
        addStock: [{ required: true, message: '请输入增加码数', trigger: 'blur' }],
        redeemCodeList: [
          { required: true, message: '请粘贴一行一码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.id = this.getPageParams().id
    this.getCouponDetails(this.id)
  },
  methods: {
    changeLinkMan(data) {

    },
    checkCodeList() {
      let list
      if (this.ruleForm.redeemCodeList && this.ruleForm.redeemCodeList.length > 0) {
        list = this.ruleForm.redeemCodeList.split('\n')
      }
      if (this.detail.type == 'DZM' && this.detail.source == 'OUT' && list && list.length > 0) {
        for (var i = 0; i < list.length; i++) {
          if (isNaN(Number(list[i])) || list[i].length < 4 || list[i].length > 12) {
            this.$message.error('请输入4-12位纯数字券码')
            return false
          }
        }
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid && this.checkCodeList()) {
          this.getHttpServices().getCouponService().post('couponSetInfo/updateStock', {
            id: this.id,
            addStock: this.ruleForm.addStock,
            redeemCodeList: this.ruleForm.redeemCodeList
          })
            .then(res => {
              this.$message.success('提交成功')
              this.getCouponDetails(this.id)
              this.visible = false
            })
            .catch(reason => this.showNetWorkErrorMessage(reason))
        } else {
          this.getLogUtils().logWithTag('error submit!!', 'error submit!!')
          return false
        }
      })
    },
    limitNumber(value) {
      if (typeof value === 'string') {
        return !isNaN(Number(value)) ? value.replace(/\./g, '') : 0
      } else if (typeof value === 'number') {
        return !isNaN(value) ? String(value).replace(/\./g, '') : 0
      } else {
        return 0
      }
    },
    addNum() {
      if (this.ruleForm.addStock) {
        this.ruleForm.addStock = ''
      }
      if (this.ruleForm.redeemCodeList) {
        this.ruleForm.redeemCodeList = ''
      }
      this.visible = true
    },
    getCouponDetails(id) {
      this.getHttpServices().getCouponService().post('couponSetInfo/selectCouponDetailById/' + id)
        .then(detail => {
          this.detail = detail
          if (detail && detail.type == 'JHM') {
            this.$nextTick(() => {
              this.$refs.linkMan.getLinkInfo(detail.activateContractInfo, detail.activateMustContractInfo)
            })
          }
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getDateStr(detail) {
      if (detail.timeType === 1 || detail.timeType === '1') {
        return '长期有效'
      }
      if (detail.timeType === 2 || detail.timeType === '2') {
        return '购买后' + detail.days + '天内'
      }
      if (detail.timeType === 3 || detail.timeType === '3') {
        return detail.validStartTime + '至' + detail.validEndTime
      }
      return ''
    }
  }

}
</script>
<style scoped>
</style>